









import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class ListRating extends Vue {

  @Prop({ type: Number, default: 5})
  readonly rating!: number;

  public getColor(rating: number) {
    if (rating >= 5) { // 4-5
      return 'green';
    } else if (rating >= 2) { // 2-3
      return 'amber';
    } else if (rating >= 1) { // 1
      return 'orange';
    } else if (rating >= 0) { // 0
      return 'red';
    } else {
      return 'grey'
    }
  }
}
